import LogoGallery from "./LogoGallery";
export default LogoGallery;
